/**
 * PHOTO GRID COMPONENT
 * 
 * Filterable grid of photos
 */

import React from 'react';
import PhotoCard from './PhotoCard';

const PhotoGrid = ({ 
  photos = [], 
  areas = [],
  filterArea,
  filterCategory,
  onEditPhoto, 
  onRemovePhoto,
  disabled = false 
}) => {
  // Filter photos
  let filteredPhotos = [...photos];
  
  if (filterArea) {
    filteredPhotos = filteredPhotos.filter(p => p.area_id === filterArea);
  }
  
  if (filterCategory) {
    filteredPhotos = filteredPhotos.filter(p => p.category === filterCategory);
  }

  if (filteredPhotos.length === 0) {
    return (
      <div className="py-8 text-center text-slate-500">
        No photos match the current filters
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
      {filteredPhotos.map(photo => (
        <PhotoCard
          key={photo.photo_id}
          photo={photo}
          areas={areas}
          onEdit={onEditPhoto}
          onRemove={onRemovePhoto}
          disabled={disabled}
        />
      ))}
    </div>
  );
};

export default PhotoGrid;
